// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`DocumentType test Match con el snapshot 1`] = `""`;
